import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
import api from "./api.js";
export default async function callPartialReturnOrderItem(
  component,
  job_order_id,
  updateOrderArr
) {
  const Authorization = "bearer " + localStorage.getItem("token");
  const resp = await fetch(`${API_URL}rest/V1/rider/returnOrderItems`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept, Authorization },
    body: JSON.stringify({
      returnItems: {
        job_order_id: job_order_id,
        items: updateOrderArr,
      },
    }),
  })
    .then(function (response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      return response.json();
    })
    .then(function (data) {
      localStorage.setItem("callPartialReturnOrderItem",JSON.stringify(data))
      if (data && data[0] && data[0].status) {
        console.log("callPartialReturnOrderItem", data[0].status);
        component &&
          component.setState({
            returnOrderItemstate: data[0],
          });
      }
      return data;
      // if(data[0]&&data[0].status==='success'){
      //     component.props.actionDeliverySuccessDetails(data[0].data)
      //     api.callShippingJobs(component,trip_id);
      //     let localData=JSON.parse(localStorage.getItem('orderData'));
      //     localData['deliverysuccess']={};
      //     localData.deliverysuccess=data[0].data;
      //     localStorage.setItem('orderData',JSON.stringify(localData));
      // }
    });

  return resp;
}



// WEBPACK FOOTER //
// ./src/utility/api/callPartialReturnOrderItem.js